import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MatDialog } from '@angular/material';
import { NgxSpinnerService } from 'ngx-spinner';
import { UserService } from 'src/app/services/user/user.service';
import { MessageModalComponent } from 'src/app/shared/components/modals/message/message-modal.component';
import { AppConstants } from 'src/app/shared/constants/app.contants';
import {
  AlertService,
  MessageSeverity,
} from 'src/app/shared/services/alert.service';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.css'],
})
export class UserProfileComponent implements OnInit {
  hide = true;
  repeatHide = true;
  userForm: FormGroup;
  headquarterSelect = 0;
  headquarters = [];
  showEdit: boolean = false;
  color1: string;
  color2: string;
  photo: string;
  photoPreview: string;
  photoFile: File;
  idEnteprise: number;

  constructor(
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private userService: UserService,
    private alertService: AlertService,
    public dialog: MatDialog
  ) {
    document.getElementById('titleHeaderNav').innerHTML =
      '<span class="font-weight-bold">Mi Perfil</span>';
  }

  ngOnInit() {
    this.color1 = localStorage.getItem(AppConstants.Session.THEME_COLOR1);
    this.color2 = localStorage.getItem(AppConstants.Session.THEME_COLOR2);
    this.photo = localStorage.getItem(AppConstants.Session.PHOTO);
    this.idEnteprise = parseInt(
      localStorage.getItem(AppConstants.Session.ENTERPRISE)
    );

    this.createForm();
    this.setValues();
  }

  createForm() {
    this.userForm = this.formBuilder.group({
      // documentNumber: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(8)]],
      email: [
        '',
        [Validators.required, Validators.maxLength(100), Validators.email],
      ],
      names: [
        '',
        [
          Validators.required,
          Validators.maxLength(30),
          this.noWhitespaceValidator,
        ],
      ],
      lastName: [
        '',
        [
          Validators.required,
          Validators.maxLength(30),
          this.noWhitespaceValidator,
        ],
      ],
      password: ['', [Validators.minLength(6)]],
      confirmPassword: ['', [Validators.minLength(6)]],
      idHeadquarter: ['', []],
      idUser: [localStorage.getItem(AppConstants.Session.USERID)],
      // locked: [false],
    });
  }

  passwordMatcher(): boolean {
    const password = this.userForm.get('password');
    const confirmPassword = this.userForm.get('confirmPassword');

    if (password.value === confirmPassword.value) {
      return true;
    }
    return false;
  }

  get f() {
    return this.userForm.controls;
  }

  setValues() {
    this.spinner.show();
    this.userService
      .getUserById(parseInt(localStorage.getItem(AppConstants.Session.USERID)))
      .subscribe(
        (response) => {
          this.userForm.patchValue({
            // documentNumber: this.data.row.dni,
            email: response.username,
            names: response.names,
            lastName: response.lasName,
            // password: '******',
            // confirmPassword: '******',
            status: response.enabled,
            sendEmail: response.sendEmail,
            idHeadquarter: response.idHeadquarter,
            // locked: response.locked
          });
          this.headquarterSelect = !response.idHeadquarter
            ? 0
            : response.idHeadquarter;
          this.spinner.hide();
          this.photoPreview = response.photo; // Traemos la foto
          this.spinner.hide();
        },
        (error: HttpErrorResponse) => {
          this.spinner.hide();
        }
      );
  }

  public noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { whitespace: true };
  }

  save() {
    if (!this.passwordMatcher()) {
      this.alertService.showMessage(
        '',
        'No coincide la contraseña con la contraseña de confirmación',
        MessageSeverity.error
      );
      return false;
    }

    if (this.userForm.valid) {
      this.spinner.show();

      let formData = new FormData();

      // formData.append('documentNumber', this.userForm.get('documentNumber').value);
      formData.append('email', this.userForm.get('email').value);
      formData.append('names', this.userForm.get('names').value);
      formData.append('lastName', this.userForm.get('lastName').value);
      //formData.append('role', this.userForm.get('role').value);
      formData.append('password', this.userForm.get('password').value);
      formData.append(
        'confirmPassword',
        this.userForm.get('confirmPassword').value
      );
      //formData.append('status', this.userForm.get('status').value);
      //formData.append('sendEmail', this.userForm.get('sendEmail').value);
      formData.append('idHeadquarter', this.userForm.get('idHeadquarter').value);
      formData.append('idUser', this.userForm.get('idUser').value);
      // formData.append('locked', this.userForm.get('locked').value);
      formData.append('idEnterprise', this.idEnteprise.toString());
      formData.append('photo', this.photoFile);

      this.userService.updateUserMyProfile(formData).subscribe(
        (response) => {
          this.alertService.showMessage(
            AppConstants.TitleModal.UPDATE_USER,
            AppConstants.MessageModal.UPDATE_USER,
            MessageSeverity.success
          );
          if(response.code == 200){
            localStorage.setItem(
              AppConstants.Session.USER,
              this.userForm.get('names').value +
                ' ' +
                this.userForm.get('lastName').value
            );

            if(this.photoFile != null){
              localStorage.setItem(
              AppConstants.Session.PHOTO,
              this.photoPreview.toString()
              );
              window.location.reload();
            }else{
              this.spinner.hide();
            }
          }
        },
        (error: HttpErrorResponse) => {
          this.alertService.showMessage(
            AppConstants.TitleModal.UPDATE_USER,
            error.error.messages,
            MessageSeverity.error
          );
          this.spinner.hide();
        }
      );
    }else{
      this.userForm.markAllAsTouched();
    }
  }

  //FOTO DE PERFIL
  handleFileInput(event: Event) {
    const file = (event.target as HTMLInputElement).files[0];
    if (file) {
      this.photoFile = file;
      // console.log(this.photoFile);

      // Actualizar la vista para mostrar la nueva foto
      const reader = new FileReader();
      reader.onload = (e) => (this.photoPreview = reader.result as string);
      reader.readAsDataURL(file);
    }
  }

  //ELIMINAR FOTO
  deletePhoto() {
    const dialogRef = this.dialog.open(MessageModalComponent, {
      width: '250px',
      data: {
        title: AppConstants.TitleModal.DELETE_PROFILE_PHOTO,
        message:
          AppConstants.MessageModal
            .ARE_YOU_SURE_YOU_WANT_TO_DELETE_PROFILE_PHOTO,
        hasButton: true,
        contentButton: {
          yes: 'SI',
          no: 'CANCELAR',
        },
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result.result == true) {
        fetch('../../../../../../assets/images/user-noimage.png')
          .then(response => response.blob())
          .then(blob => {
            this.photoFile = new File([blob], 'user-noimage.png', { type: 'image/png' });
            this.photoPreview = '../../../../../../assets/images/user-noimage.png';
          });
      }
    });
  }
}
